<template>
  <div class="sort-filter">
    <div 
      @click="$emit('sort-default')" 
      class="filter-item" 
      :class="{ active: !priceType }"
    >
      默认推荐
    </div>
    <div class="divider"></div>
    <div @click="$emit('sort-price')" class="filter-item">
      价格 
      <van-image 
        style="margin-left: 0.2rem;" 
        width="0.6rem"
        height="0.8rem" 
        :src="priceIcon" 
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortFilter',
  props: {
    priceType: {
      type: String,
      default: null // null: 默认, '1': 升序, '0': 降序
    }
  },
  computed: {
    priceIcon() {
      if (!this.priceType) {
        return require('@/assets/images/price-no.png')
      }
      return this.priceType === '1' 
        ? require('@/assets/images/price-up.png') 
        : require('@/assets/images/price-down.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-filter {
  display: flex;
  width: 100%;
  background-color: white;
  height: 2.2rem;
  align-items: center;
  font-size: 0.85rem;
  border-top: 1px solid #f0f0f0;
}

.filter-item {
  flex: 1;
  text-align: center;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &.active {
    color: #e74c3c;
  }
}

.divider {
  background-color: #DDD;
  height: 1rem;
  width: 1px;
}
</style>
